import { Liquidity, Position } from "@perp/sdk-curie"
import { useState } from "react"
import { usePerpInitializedEffect } from "sdk-react/perpetualProtocol/usePerpInitializedEffect"
import { Handlers } from "sdk-react/tools/useHandlers"

export function usePositionMakerImpermanent(liquidity: Liquidity) {
    const [positionMakerImpermanent, setPositionMakerImpermanent] = useState<Position>()
    const { getHandlers } = Handlers.useContainer()
    const { onError } = getHandlers()

    usePerpInitializedEffect(() => {
        // TODO: [429 issue] check if we can reduce contract calls
        const unsubscribeLiquidityAmountsUpdated = liquidity.on("updated", async (liquidityNext: Liquidity) => {
            try {
                const position = await liquidityNext.getMakerPositionImpermanent()
                setPositionMakerImpermanent(position)
            } catch (e: any) {
                onError(e)
            }
        })
        return () => {
            unsubscribeLiquidityAmountsUpdated()
        }
    }, [liquidity])

    return positionMakerImpermanent
}
